import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _cloneDeep from "lodash/cloneDeep";
var _excluded = ["text", "url", "newWindow"],
  _excluded2 = ["autoFocus"],
  _excluded3 = ["text"],
  _excluded4 = ["text"],
  _excluded5 = ["text"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import { useCallback, useEffect, useState } from 'react';
import classnames from 'classnames';
import { useShowHidePricingFormWithZip } from "../../Utility/Hooks";
import { Button } from "../../Button/Button/Button";
import { Container } from "../../Container/Container/Container";
import { ChangeDuration } from "../../Price/ChangeDuration/ChangeDuration";
import { ChangePlan } from "../../Price/ChangePlan/ChangePlan";
import { Modal } from "../../Modal/Modal/Modal";
import { PricingForm } from "../../Price/PricingForm/PricingForm";
import { Text } from "../../Text/Text/Text";
import { TextPrice } from "../../Price/TextPrice/TextPrice";
import { SkeletonIndicator } from "../../Indicator/SkeletonIndicator/SkeletonIndicator";
import { PromoCodeInput } from "../../Input/PromoCodeInput/PromoCodeInput";
import styles from "./PlansDurationSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PlansDurationSlice = function PlansDurationSlice(_ref) {
  var _changePlan$items;
  var _ref$version = _ref.version,
    propVersion = _ref$version === void 0 ? 'modal' : _ref$version,
    changeDuration = _ref.changeDuration,
    changePlan = _ref.changePlan,
    changePlanCTA = _ref.changePlanCTA,
    planCancel = _ref.planCancel,
    cta = _ref.cta,
    planSubmit = _ref.planSubmit,
    _ref$onPlanSubmit = _ref.onPlanSubmit,
    onPlanSubmit = _ref$onPlanSubmit === void 0 ? function () {} : _ref$onPlanSubmit,
    _ref$onPlanChange = _ref.onPlanChange,
    onPlanChangeInit = _ref$onPlanChange === void 0 ? function () {} : _ref$onPlanChange,
    _ref$onDurationChange = _ref.onDurationChange,
    onDurationChange = _ref$onDurationChange === void 0 ? function () {} : _ref$onDurationChange,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    _ref$headlineTypog = _ref.headlineTypog,
    headlineTypog = _ref$headlineTypog === void 0 ? 'headline4' : _ref$headlineTypog,
    _ref$subheadline = _ref.subheadline,
    subheadline = _ref$subheadline === void 0 ? '' : _ref$subheadline,
    _ref$subheadlineTypog = _ref.subheadlineTypog,
    subheadlineTypog = _ref$subheadlineTypog === void 0 ? 'subhead1' : _ref$subheadlineTypog,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description,
    _ref$descriptionFeatu = _ref.descriptionFeaturesTitle,
    descriptionFeaturesTitle = _ref$descriptionFeatu === void 0 ? '' : _ref$descriptionFeatu,
    _ref$descriptionFeatu2 = _ref.descriptionFeatures,
    descriptionFeatures = _ref$descriptionFeatu2 === void 0 ? [] : _ref$descriptionFeatu2,
    _ref$descriptionFeatu3 = _ref.descriptionFeaturesTitle2,
    descriptionFeaturesTitle2 = _ref$descriptionFeatu3 === void 0 ? '' : _ref$descriptionFeatu3,
    _ref$descriptionFeatu4 = _ref.descriptionFeatures2,
    descriptionFeatures2 = _ref$descriptionFeatu4 === void 0 ? [] : _ref$descriptionFeatu4,
    _ref$modalHeadlineTyp = _ref.modalHeadlineTypog,
    modalHeadlineTypog = _ref$modalHeadlineTyp === void 0 ? 'headline3' : _ref$modalHeadlineTyp,
    pricing = _ref.pricing,
    pricingError = _ref.pricingError,
    _ref$showPricingForm = _ref.showPricingForm,
    showPricingFormInit = _ref$showPricingForm === void 0 ? false : _ref$showPricingForm,
    textPrice = _ref.textPrice,
    promoCodeInput = _ref.promoCodeInput,
    _ref$showPromoField = _ref.showPromoField,
    showPromoField = _ref$showPromoField === void 0 ? false : _ref$showPromoField,
    _ref$mobileCarousel = _ref.mobileCarousel,
    mobileCarousel = _ref$mobileCarousel === void 0 ? false : _ref$mobileCarousel,
    sideBySideDisplay = _ref.sideBySideDisplay;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    autoFocusPromo = _useState4[0],
    setAutoFocusPromo = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showPromoCodeField = _useState6[0],
    setShowPromoCodeField = _useState6[1];

  // The toggleV2 option is accepted only when there are exactly 2 plans.
  var version = propVersion === 'toggleV2' && (changePlan === null || changePlan === void 0 ? void 0 : (_changePlan$items = changePlan.items) === null || _changePlan$items === void 0 ? void 0 : _changePlan$items.length) !== 2 ? 'modal' : propVersion;
  useEffect(function () {
    setShowPromoCodeField(showPromoField);
  }, [showPromoField]);
  var handleOpen = function handleOpen() {
    setModalOpen(true);
  };
  var handleClose = function handleClose() {
    setModalOpen(false);
  };
  var onSubmit = function onSubmit() {
    onPlanSubmit();
    setModalOpen(false);
  };
  var onPlanChange = function onPlanChange(plan) {
    onPlanChangeInit(plan);
    if (version === 'switcher' || version === 'toggle' || version === 'toggleV2') {
      onSubmit();
    }
  };
  var onChange = useCallback(function (duration) {
    onDurationChange(duration);
  }, [onDurationChange]);
  var _useShowHidePricingFo = useShowHidePricingFormWithZip(showPricingFormInit),
    autoFocus = _useShowHidePricingFo.autoFocus,
    showPricingForm = _useShowHidePricingFo.showPricingForm,
    onZipClick = _useShowHidePricingFo.onZipClick;
  var onPromoClick = function onPromoClick() {
    setAutoFocusPromo(true);
    setShowPromoCodeField(!showPromoCodeField);
  };
  var renderCTA = function renderCTA() {
    var _ref2 = cta || {},
      text = _ref2.text,
      url = _ref2.url,
      newWindow = _ref2.newWindow,
      otherProps = _objectWithoutProperties(_ref2, _excluded);
    return text && /*#__PURE__*/_jsx("div", {
      className: styles.button,
      children: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        type: "link",
        url: url,
        newWindow: newWindow
      }, otherProps), {}, {
        children: /*#__PURE__*/_jsx(Text, {
          typog: "bodycopyLarge",
          textElement: "span",
          childrenInline: true,
          children: text
        })
      }))
    });
  };
  var renderItem = function renderItem(item, key) {
    if (!item.text) {
      return null;
    }
    return /*#__PURE__*/_jsx("li", {
      className: classnames(styles.featureItem, item.included === true ? styles.includedItem : styles.excludedItem),
      children: /*#__PURE__*/_jsx(Text, {
        typog: "subhead4",
        className: styles.featureItemText,
        children: item.text
      })
    }, key);
  };
  var renderPromoInput = function renderPromoInput() {
    var _promoCodeInput$cta;
    if (!promoCodeInput) return;
    var autoFocus = promoCodeInput.autoFocus,
      otherProps = _objectWithoutProperties(promoCodeInput, _excluded2);
    if (promoCodeInput !== null && promoCodeInput !== void 0 && (_promoCodeInput$cta = promoCodeInput.cta) !== null && _promoCodeInput$cta !== void 0 && _promoCodeInput$cta.text) {
      promoCodeInput.cta.onClick = onPromoClick;
    }
    return /*#__PURE__*/_jsx(PromoCodeInput, _objectSpread({
      containerClassName: styles.promoCodeInputContainer,
      showPromoField: showPromoCodeField,
      autoFocus: autoFocusPromo
    }, otherProps));
  };
  var renderChangePlan = function renderChangePlan() {
    switch (version) {
      case 'switcher':
      case 'toggle':
        {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [headline && /*#__PURE__*/_jsx(Text, {
              typog: headlineTypog,
              children: /*#__PURE__*/_jsx("div", {
                className: styles.headlineSwitcherToggle,
                children: headline
              })
            }), /*#__PURE__*/_jsx(ChangePlan, _objectSpread({
              onChange: onPlanChange,
              version: version
            }, changePlan))]
          });
        }
      case 'modal':
      case 'toggleV2':
      default:
        {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [headline && /*#__PURE__*/_jsxs(Text, {
              typog: modalHeadlineTypog,
              childrenInline: true,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.headline,
                children: headline
              }), !subheadline && renderChangePlanCTA()]
            }), subheadline && /*#__PURE__*/_jsxs(Text, {
              typog: subheadlineTypog,
              className: styles.subheadlineWrapper,
              childrenInline: true,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.subheadline,
                children: subheadline
              }), renderChangePlanCTA()]
            }), (textPrice === null || textPrice === void 0 ? void 0 : textPrice.text) && /*#__PURE__*/_jsx(TextPrice, {
              text: textPrice.text,
              price: textPrice.price || '',
              typog: textPrice.typog || 'subhead1',
              typogPriceText: textPrice.typogPriceText || 'subhead1',
              className: classnames(styles.price, styles.text),
              priceClass: styles.text
            }), description && /*#__PURE__*/_jsx(Text, {
              className: styles.description,
              typog: "bodycopyLarge",
              richText: true,
              children: description
            }), descriptionFeaturesTitle && /*#__PURE__*/_jsx(Text, {
              typog: "bodycopyLarge",
              className: styles.descriptionFeatureTitle1,
              children: descriptionFeaturesTitle
            }), descriptionFeatures && descriptionFeatures.length > 0 && /*#__PURE__*/_jsx("ul", {
              className: styles.descriptionFeature,
              children: descriptionFeatures === null || descriptionFeatures === void 0 ? void 0 : descriptionFeatures.map(function (name, idx) {
                return renderItem(name, idx);
              })
            }), descriptionFeaturesTitle2 && /*#__PURE__*/_jsx(Text, {
              typog: "bodycopyLarge",
              children: descriptionFeaturesTitle2
            }), descriptionFeatures2 && descriptionFeatures2.length > 0 && /*#__PURE__*/_jsx("ul", {
              className: styles.descriptionFeature,
              children: descriptionFeatures2 === null || descriptionFeatures2 === void 0 ? void 0 : descriptionFeatures2.map(function (name, idx) {
                return renderItem(name, idx);
              })
            })]
          });
        }
    }
  };
  var renderChangePlanCTA = function renderChangePlanCTA() {
    var _ref3 = planCancel || {},
      planCancelText = _ref3.text,
      planCancelOtherProps = _objectWithoutProperties(_ref3, _excluded3);
    var _ref4 = planSubmit || {},
      planSubmitText = _ref4.text,
      planSubmitOtherProps = _objectWithoutProperties(_ref4, _excluded4);
    var _ref5 = changePlanCTA || {},
      text = _ref5.text,
      otherProps = _objectWithoutProperties(_ref5, _excluded5);
    var multiplePlans = (changePlan === null || changePlan === void 0 ? void 0 : changePlan.items) && changePlan.items.length > 1;
    if (text && version === 'toggleV2') {
      return /*#__PURE__*/_jsx(ChangePlan, _objectSpread({
        className: styles.plan,
        onChange: onPlanChange,
        version: version,
        changePlanCTA: changePlanCTA
      }, changePlan));
    }
    return text && multiplePlans && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
        type: "link",
        onClick: handleOpen,
        className: styles.change
      }, otherProps), {}, {
        children: text
      })), modalOpen && /*#__PURE__*/_jsxs(Modal, {
        onClose: handleClose,
        closeFixed: false,
        children: [/*#__PURE__*/_jsx(ChangePlan, _objectSpread(_objectSpread({
          className: styles.plan,
          onChange: onPlanChange,
          version: version
        }, changePlan), {}, {
          headlineTypog: 'headline3'
        })), /*#__PURE__*/_jsxs("div", {
          className: styles.actions,
          children: [planCancelText && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            type: "link",
            onClick: handleClose,
            className: styles.link
          }, planCancelOtherProps), {}, {
            children: planCancelText
          })), planSubmitText && /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            type: "primary",
            onClick: onSubmit,
            className: styles.submit
          }, planSubmitOtherProps), {}, {
            children: planSubmitText
          }))]
        })]
      })]
    });
  };
  var renderPricingForm = function renderPricingForm() {
    var renderedPricing = pricing ? _cloneDeep(pricing) : false;
    if (renderedPricing && renderedPricing.input) {
      renderedPricing.input.autoFocus = autoFocus;
      renderedPricing.input.className = styles.pricingFormInput;
      renderedPricing.input.arrowButton = true;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [!renderedPricing && /*#__PURE__*/_jsxs("div", {
        className: styles.skeletonWrapper,
        children: [/*#__PURE__*/_jsx(SkeletonIndicator, {}), /*#__PURE__*/_jsx(SkeletonIndicator, {}), /*#__PURE__*/_jsx(SkeletonIndicator, {})]
      }), renderedPricing && renderedPricing.zipText && /*#__PURE__*/_jsx(PricingForm, {
        className: styles.pricingForm,
        pricing: renderedPricing,
        isOpen: showPricingForm,
        onZipClick: onZipClick,
        zipTypog: "bodycopyLarge"
      }), (pricingError === null || pricingError === void 0 ? void 0 : pricingError.text) && /*#__PURE__*/_jsx(Text, {
        typog: "bodycopyLarge",
        className: classnames(styles.error, {
          [styles.red]: pricingError.red
        }),
        children: pricingError.text
      })]
    });
  };
  if (sideBySideDisplay) {
    var _promoCodeInput$cta2;
    return /*#__PURE__*/_jsx("div", {
      className: styles.outerWrapper,
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.wrapper, styles.wrapperSideBySide),
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.header,
            children: [renderChangePlan(), ((promoCodeInput === null || promoCodeInput === void 0 ? void 0 : (_promoCodeInput$cta2 = promoCodeInput.cta) === null || _promoCodeInput$cta2 === void 0 ? void 0 : _promoCodeInput$cta2.text) || (promoCodeInput === null || promoCodeInput === void 0 ? void 0 : promoCodeInput.promoCodeCheckoutMessage)) && renderPromoInput(), renderCTA(), renderPricingForm()]
          }), changeDuration && /*#__PURE__*/_jsx("div", {
            className: styles.widenSideBySide,
            children: /*#__PURE__*/_jsx(ChangeDuration, _objectSpread({
              onChange: onChange,
              mobileCarousel: mobileCarousel
            }, changeDuration))
          })]
        })
      })
    });
  } else {
    var _promoCodeInput$cta3;
    return /*#__PURE__*/_jsx("div", {
      className: styles.outerWrapper,
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs("div", {
          className: classnames(styles.wrapper, {
            [styles.wrapperSwitcherToggle]: version === 'toggle' || version === 'switcher'
          }),
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.header,
            children: [renderChangePlan(), ((promoCodeInput === null || promoCodeInput === void 0 ? void 0 : (_promoCodeInput$cta3 = promoCodeInput.cta) === null || _promoCodeInput$cta3 === void 0 ? void 0 : _promoCodeInput$cta3.text) || (promoCodeInput === null || promoCodeInput === void 0 ? void 0 : promoCodeInput.promoCodeCheckoutMessage)) && renderPromoInput(), renderCTA(), renderPricingForm()]
          }), changeDuration && /*#__PURE__*/_jsx(ChangeDuration, _objectSpread({
            onChange: onChange,
            mobileCarousel: mobileCarousel
          }, changeDuration))]
        })
      })
    });
  }
};